/** Returns true when the string passes a basic email format check. */
export function isValidEmail(v: string): boolean {
  const s = v.trim();
  if (!s) return false;
  const at = s.lastIndexOf('@');
  if (at < 1) return false;              // nothing before @
  const domain = s.slice(at + 1);
  if (!domain.includes('.')) return false; // no dot in domain
  if (domain.startsWith('.')) return false;
  if (domain.endsWith('.')) return false;  // trailing dot (sibnarayan@adibashost.)
  const tld = domain.split('.').pop() ?? '';
  if (tld.length < 2) return false;       // TLD too short
  if (/\s/.test(s)) return false;
  return true;
}

/** Returns true when username matches [a-z0-9_] with at least 3 characters. */
export function isValidUsername(v: string): boolean {
  return /^[a-z0-9_]{3,}$/.test(v);
}

/** Lowercases a username. Use at submit time; do not trim during typing. */
export function normalizeUsername(v: string): string {
  return v.toLowerCase();
}
